module.exports = __webpack_public_path__ + "static/media/megha-ravi.7978a4e8.jpg";